import {
  FilterType,
  IdFilterCategory,
  buildGetBookingsDataTableFilter,
  useGetBookingsDataTable,
} from 'generated/resources/datatable.graphql'
import { LocationsForBookingsQuery } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const locationFilter = (
  source: ReturnType<typeof useGetBookingsDataTable>,
  locations: LocationsForBookingsQuery['locations']['locations']
) => {
  const options = locations.map((location) => {
    return {
      value: location.id,
      label: location.name,
    }
  })
  return buildGetBookingsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      } as IdFilterCategory,
    ],
    identifier: 'locationIdFilter',
    onUpdateValue: () => {
      track(trackingEvents.spaceControl.bookings.filterBookings, {
        filter_used: 'locationId',
      })
    },
    path: 'locationId',
    title: i18n.t('space_control.my-bookings.datatable.filters.location'),
  })
}

export default locationFilter
